/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

import {
  saveDescriptionOfInvoiceField,
  saveDescriptionOfInvoiceItem,
  // saveVendorName,
  // saveVendorAddress,
  saveDOIHeaderPartyName,
  saveDOIHeaderPartyAddress,
  saveTotals,
  saveDOIWaiverStatus
} from '../api/setFormData'
import {
  calculateTotals
} from './util'
import * as actions from '../actions/actionTypes'
const initialState = {}

// UPDATE functions control input, SAVE functions call API's and change dependent fields
export default function DescriptionOfInvoiceReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case 'INITIALIZE_VALUES_DESCRIPTION_OF_INVOICE': {
      if(!action.payload){
        return state;
      }
      let payload = JSON.parse(action.payload);
      // console.log("init invoice", action.payload.invoices);
      return Object.assign({}, state, { ...payload })
    }
    case 'UPDATE_INVOICE_FIELD': {
      return Object.assign({}, state, { [action.field]: action.payload })
    }
    case 'UPDATE_INVOICE_HEADERPARTY_ITEM': {
      let newLineItems = state.invoices.slice()
      newLineItems[action.index][action.field] = action.payload
      return Object.assign({}, state, { invoices: newLineItems })
    }
    case 'UPDATE_INVOICE_ITEM_FIELD': {
      let newLineItems = state.invoices.slice()
      newLineItems[action.index][action.field] = action.payload
      return Object.assign({}, state, { invoices: newLineItems })
    }
    case 'UPDATE_INVOICE_ACTOR_ADDRESS': {
     // console.log('action.payload', action)
      var _newLineItems = state.invoices.slice()
     // console.log(_newLineItems[action.index]['addressInfo'][action.field]);
      let newAddress = Object.assign({}, _newLineItems[action.index]['addressInfo'])
      newAddress[action.field] = action.payload
      _newLineItems[action.index]['addressInfo'] = newAddress
      return Object.assign({}, state, { invoices: _newLineItems })
    }
    case 'ADD_INVOICE_ITEM': {
      let newInvoiceList = state.invoices.slice()
        if(action.newInvoiceItem){
          newInvoiceList.push(action.newInvoiceItem);
        }
      return Object.assign({}, state, { invoices: newInvoiceList })
    }
    case 'REMOVE_INVOICE_ITEM': {
      let lineItemsCopy = state.invoices.slice()
      let newLineItems = lineItemsCopy
        .slice(0, action.index)
        .concat(lineItemsCopy.slice(action.index + 1))
      return Object.assign({}, state, { invoices: newLineItems })
    }
    case 'SAVE_INVOICE_FIELD': {
      saveDescriptionOfInvoiceField(action.field, state[action.field])
      return state
    }
    // case 'SAVE_VENDOR_NAME': {
    //   saveVendorName(
    //     state.invoices[action.index].invoiceId,
    //     state.invoices[action.index].vendorId,
    //     state.invoices[action.index][action.field]
    //   )
    //   return state
    // }
    // case 'SAVE_VENDOR_ADDRESS': {
    //   saveVendorAddress(
    //     state.invoices[action.index].invoiceId,
    //     state.invoices[action.index].vendorId,
    //     state.invoices[action.index]['addressInfo'] 
    //   )
    //   return state
    // }
    
    case 'SAVE_INVOICE_ITEM': {
      saveDescriptionOfInvoiceItem(
        state.invoices[action.index].invoiceId,
        action.field,
        action.value ? action.value : state.invoices[action.index][action.field],
        action.formType
      )
      return state
    }
    case actions.ADD_MERCH_ID_TO_INVOICE: {
      var _newLineItems = state.invoices.slice()
      _newLineItems.map(function(item){
        if(item.invoiceId === action.invoiceId){
          item.merchandiseList.push(action.merchandiseId);
          return item;
        }
      })
      return Object.assign({}, state, { invoices: _newLineItems })
    }
    case actions.REMOVE_MERCH_ID_FROM_INVOICE: {
      var _newLineItems = state.invoices.slice();
          _newLineItems.map((item)=>{
            item.merchandiseList = item.merchandiseList.filter(function(item2){
              return (item2 !== action.merchandiseId)
            })
        })
      return Object.assign({}, state, { invoices: _newLineItems })
    }
    case actions.UPDATE_TOTALS: {
      return Object.assign({}, state, { ...action.fields })
    }
    case actions.UPDATE_HTS_CONTEXT: {
      let newLineItems = state.invoices.slice()
      action.htsItems.forEach(item => {
        Object.assign(
          newLineItems[item.lineItemIndex].merchandiseDuties[item.dutyIndex],
          { ...item.vals }
        )
      })
      return Object.assign({}, state, { invoices: newLineItems })
    }
    case actions.ON_CURRENCY_CODE_OR_DIRECT_SHIPMENT_DATE_CHANGED: {
      let newLineItems = state.invoices.slice()
      // console.log("step2",action.response.exchRate)
      newLineItems.map((item, index)=>{
          if(item.invoiceId === action.invoiceId){
            item.exchangeRate = action.response.exchRate || '-999'
            saveDescriptionOfInvoiceItem(
              item.invoiceId,
              "exchangeRate",
              item.exchangeRate
            )
          }
        })
        setTimeout(()=>{
          return Object.assign({}, state, { invoices: newLineItems })
        }, 0)
      }

      case actions.UPDATE_DOI_HEADERPARTY_ITEM: {
        let newLineItems = state.invoices.slice()
        newLineItems.map((item, index)=>{ 
          if(item.invoiceId === action.invoiceId){
            newLineItems[index][action.field] = action.payload
          }
        })
        return Object.assign({}, state, { invoices: newLineItems })
      }
  
  
      case actions.SAVE_DOI_HEADER_PARTY_NAME: {
        
        saveDOIHeaderPartyName(
          action.formType,
          action.invoiceId,
          action.merchandiseId,
          action.vendorId,
          action.field,
          action.payload
        )
        return state
      }

       case actions.UPDATE_WAIVER_STATUS: {
        let newLineItems = state.invoices.slice()
        newLineItems.map((item, index)=>{ 
          if(item.invoiceId === action.invoiceId){
            newLineItems[index][action.field] = action.payload
          }
        })
        return Object.assign({}, state, { invoices: newLineItems })
      }
  
  
      case actions.SAVE_WAIVER_STATUS: {
        
        saveDOIWaiverStatus(
          action.invoiceId,
          action.manufacturerId,
          action.field,
          action.payload
        )
        return state
      }
  
      case actions.UPDATE_DOI_ACTOR_ADDRESS: {
        var _newLineItems = state.invoices.slice();
        _newLineItems.map((item)=>{ 
          if(item.invoiceId === action.invoiceId){
            let newAddress = ["VENDOR","vendor"].includes(action.formType) ?Object.assign({}, item['addressInfo']):Object.assign({}, item['mfgAddressInfo'])
            newAddress[action.field] = action.payload;
            if(["VENDOR","vendor"].includes(action.formType)){
            item.addressInfo = newAddress;}
            else{
              item.mfgAddressInfo = newAddress
            }
          }
        })
         return Object.assign({}, state, { invoices: _newLineItems })
       }
      
       case actions.SAVE_DOI_HEADER_PARTY_ADDRESS : {
        var _newLineItems = state.invoices.slice();
        _newLineItems.map((item)=>{ 
          if(item.invoiceId === action.invoiceId){
            saveDOIHeaderPartyAddress(
              action.formType,
              action.invoiceId,
              action.merchandiseId,
              action.vendorId,
              ["VENDOR","vendor"].includes(action.formType)?item['addressInfo'] :item['mfgAddressInfo'] 
            )
          }
        }) 
      }

      //  For Invoice Delivery Party

      case actions.UPDATE_CFIAPGA_FIELDS :{
        var _newLineItems = state.invoices.slice();
        _newLineItems.map((item)=>{ 
          if(item.invoiceId === action.invoiceId){
            let cfiaPGADetails = item.cfiaPGADetails
            // console.log({cfiaPGADetails})
            let elements  =  cfiaPGADetails.elements.map(item=>{
                if(item.elementName ===action.field){
                  item.uiVals = action.payload
                }
                return item
            })
            cfiaPGADetails.elements = elements
          }
        })
        // console.log(_newLineItems)

        return Object.assign({},state,{invoices:_newLineItems})
      }

    default:
      return state
  }
}
